import React from 'react'
import './index.css'
import './local-styles.scss'
import App from './App'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './store/configureStore'

const container = document.getElementById('root') as Element
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
)
